module.exports = __webpack_public_path__ + "static/img/kosha-risk assessment-pt.c23ecff.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/kosha-risk assessment-pt.jpg
// module id = V3R2
// module chunks = 0